import { z } from "zod";
import { useValidationControl } from "@/hooks/useValidationControl";
import { useTranslation } from "@/hooks/useTranslation";

export const useBankDetailsSchema = () => {
  const { enabled } = useValidationControl();
  const t = useTranslation("bank_details");

  if (!enabled) {
    return z.object({
      account_holder: z.string().optional(),
      account_number: z.string().optional(),
      sort_code: z.string().optional(),
      start_date: z.string().optional(),
    });
  }

  return z.object({
    account_holder: z.string().min(1, {
      message: t("errors.account-holder-required") as string,
    }),
    account_number: z
      .string()
      .min(1, { message: t("errors.account-number-invalid") as string })
      .regex(/^\d{8}$/, {
        message: t("errors.account-number-invalid") as string,
      }),
    sort_code: z
      .string()
      .min(1, { message: t("errors.sort-code-invalid") as string })
      .regex(/^\d{6}$/, {
        message: t("errors.sort-code-invalid") as string,
      }),
    start_date: z
      .string()
      .min(1, { message: t("errors.start-date-required") as string }),
  });
};

export type BankDetailsSchemaInput = z.infer<
  ReturnType<typeof useBankDetailsSchema>
>;
